import React from "react"
import "./src/styles/global.css"
import Layout from "./src/components/layout"

export const wrapPageElement = ({ element, props }) => {
  const pathname = props?.location?.pathname ?? "/"
  return <Layout pathname={pathname}>{element}</Layout>
}
